<template>
    <div>
        <h1 style="font-size: 24px; color: black;">投放代理数据</h1>
        <el-card class="form-container" shadow="never">
            <el-form :inline="true" :model="queryData" size="small" label-width="100px">
                <el-form-item label="应用：">
                    <el-select v-model="queryData.appId" placeholder="请选择"  >
                        <el-option :key="-1" label="全部" :value = "-1"></el-option>
                        <el-option v-for="app in appList"
                                   :key="app.appId"
                                   :label="app.appName"
                                   :value="app.appId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="媒体：">
                    <el-select v-model="queryData.mediaId" placeholder="请选择"  >
                        <el-option :key="-1" label="全部" :value = "-1"></el-option>
                        <el-option v-for="(value, key) in mediaObj"
                                   :key="Number(key)"
                                   :label="value"
                                   :value="Number(key)"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="日期：">
                    <el-date-picker
                            v-model="queryData.timeDate"
                            type="daterange"
                            :clearable="false"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd">
                    </el-date-picker>&emsp;&emsp;
                </el-form-item>
                <el-form-item label=" " class="sub-sub10">
                    <el-button type="primary" @click="query">查询</el-button>
                    <el-button type="primary" @click="downloadData">导出</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <div style="margin-top: 20px">
            <el-table :data="dataList"
                      style="width: 100%"
                      border
                      :header-cell-style="{background:'#303133'}"
                      element-loading-text="拼命加载中"
                      element-loading-spinner="el-icon-loading"
                      element-loading-background="rgba(0, 0, 0, 0.8)"
                      v-loading="loading">
                <el-table-column label="编号" align="center" prop="id"></el-table-column>
                <el-table-column label="时间" align="center">
                    <template slot-scope="scope" >
                        {{scope.row.dt | dateFormat}}
                    </template>
                </el-table-column>
                <el-table-column label="媒体平台"  align="center">
                    <template slot-scope="scope">
                        {{scope.row.mediaId | commonFilter(mediaObj)}}
                    </template>
                </el-table-column>
                <el-table-column label="应用名称"  align="center">
                    <template slot-scope="scope">
                        {{scope.row.appId | commonFilter(appObj)}}
                    </template>
                </el-table-column>
                <el-table-column label="账面消耗" prop="cost" align="center" ></el-table-column>
                <el-table-column label="真实消耗" prop="realCost" align="center" ></el-table-column>
                <el-table-column label="投放主体" prop="keyword" align="center" ></el-table-column>
                <el-table-column label="有价新增" prop="register" align="center" ></el-table-column>
                <el-table-column label="返点" prop="fallbackRate" align="center" ></el-table-column>
                <el-table-column label="服务点" prop="serviceRate" align="center" ></el-table-column>
                <el-table-column label="展示" prop="impress" align="center" ></el-table-column>
                <el-table-column label="点击" prop="clicks" align="center" ></el-table-column>
                <el-table-column label="ecpm" prop="ecpm" align="center" ></el-table-column>
            </el-table>
        </div>
        <div>
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page.page"
                    :page-sizes="[10,20,50,100]"
                    :page-size="page.size"
                    layout="total, sizes, prev, pager, next"
                    :total="page.totalElements">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import {
        searchProxyReport
    } from "@/http/outApi";
    import settingMix from '@/utils/mix/common-setting'
    import utils from '@/utils'
    import Export from '@/utils/ExportData'
    import {dateFormat, commonFilter1} from "../../filters";

    export default {
        name: "ProxyDataReport",
        mixins: [settingMix],
        data(){
            return{
                queryData:{
                    mediaId:-1,
                    timeDate:['',''],
                    appId: -1
                },
                page: {
                    size: 10,
                    page: 1,
                    totalElements: null
                },
                mediaType:2,
                needGetApp: true,
                needGetMedia:true,
                dataList:[],
                loading:true,
                appList:[],
                mediaObj: {},
                excelHeaders:[
                    { id: '编号' },
                    { dt: '时间' },
                    { mediaId: '媒体平台' },
                    { appId: '应用' },
                    { cost: '账面消耗' },
                    { realCost: '真实消耗' },
                    { keyword: '投放主体'},
                    { register: '有价新增' },
                    { fallbackRate: '返点' },
                    { serviceRate: '服务点' },
                    { impress: '展示' },
                    { clicks: '点击' },
                    { ecpm: 'ecpm' },
                ]
            }
        },
        methods:{
            formatDate: function(column,format) {
                return utils.DateUtil.formatDate(column, format)
            },
            handleSizeChange(size) {
                this.page.size = size;
                this.query();
            },
            handleCurrentChange(page) {
                this.page.page = page;
                this.query();
            },
            query(){
                this.queryData.page = this.page.page;
                this.queryData.size = this.page.size;
                if (this.queryData.timeDate === null) {
                    this.queryData.timeDate = ['',''];
                }
                this.queryData.startDt = this.queryData.timeDate[0] ===''?null:this.queryData.timeDate[0];
                this.queryData.endDt = this.queryData.timeDate[1]===''?null:this.queryData.timeDate[1];
                this.loading = true;
                searchProxyReport(this.queryData).then(resp=>{
                    if (resp.data.status===0){
                        this.loading = false;
                        this.dataList=resp.data.info.list;
                        this.page.totalElements =resp.data.info.total;
                    }
                });
            },
            downloadData(){
                if (this.queryData.timeDate === null) {
                    this.queryData.timeDate = ['',''];
                }
                this.queryData.startDt = this.queryData.timeDate[0] ===''?null:this.queryData.timeDate[0];
                this.queryData.endDt = this.queryData.timeDate[1]===''?null:this.queryData.timeDate[1];
                this.loading = true;
                searchProxyReport(Object.assign(this.queryData,{size: 100000, page: 1})).then(resp=>{
                    if (resp.data.status===0){
                        this.loading = false;
                        // this.dataList=resp.data.info.list;
                        // this.page.totalElements =resp.data.info.total;
                        resp.data.info.list.forEach(item => {
                            item.dt = dateFormat(item.dt)
                            item.mediaId = commonFilter1(item.mediaId,this.mediaObj)
                            item.appId = commonFilter1(item.appId,this.appObj)
                        })
                        Export.downloadExl(resp.data.info.list, '投放代理数据报表', this.excelHeaders)
                    }
                });
            }
        },
        created () {
            this.query();
        }
    }
</script>

<style scoped>

</style>